<template>
<div class="chapter">
<div class="inner_page">
<h1>101 Things to Do With Canned Biscuits</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Helpful Hints</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">Appetizers </a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Breads </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Breakfast </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Lunch </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Dinner </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Desserts </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01toc.vue?727e8208